import { combineReducers } from 'redux';

import recoveryRadarTrackerDataReducer from './recoveryRadarTrackerDataReducer';
import recoveryRadarTrackerUiReducer from './recoveryRadarTrackerUiReducer';

export default combineReducers({
  data: recoveryRadarTrackerDataReducer,
  ui: recoveryRadarTrackerUiReducer,
});
